import { classes as htmlClasses } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { createCategoryUrl } from '~/components/CategoryBlocks/utils';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';

import { CategoryBlockBackgroundImage } from '../CategoryBlockBackgroundImage';
import {
  bentoTileRatios,
  bentoTileSizes,
  resolveTileSpans,
  TILE_DESKTOP_MIN_WIDTH,
  TILE_WIDTHS,
} from '../GridView';
import type { BrandCardProps } from './interfaces';

const IMAGE_HEIGHT_RATIO = 1.5;

const BrandCard = ({
  category,
  classes,
  tileSize = 1,
  imageSizes,
  imageAspectRatio,
  priority = false,
}: BrandCardProps) => {
  const { name, id, previewImage } = category;
  const { root: className, titleClassName } = classes || {};

  const { handleClickCategory } = useCategoryAnalytics();

  const spans = resolveTileSpans(tileSize);
  const tileRatio = imageAspectRatio ?? bentoTileRatios(spans);
  const tileSizes = imageSizes ?? bentoTileSizes(spans);

  return (
    <Link
      to={createCategoryUrl({ id })}
      onClick={handleClickCategory(id)}
      className={htmlClasses([
        'relative block h-full w-full overflow-hidden desktop:rounded-6 rounded-5',
        className,
      ])}
    >
      {previewImage && (
        <div className="pointer-events-none absolute inset-x-0 top-0 h-[150%]">
          <CategoryBlockBackgroundImage
            priority={priority}
            mobile={{
              src: previewImage,
              aspectRatio: tileRatio.mobile / IMAGE_HEIGHT_RATIO,
              sizes: tileSizes,
              widths: TILE_WIDTHS,
              gravity: 'top',
            }}
            desktop={{
              src: previewImage,
              aspectRatio: tileRatio.desktop / IMAGE_HEIGHT_RATIO,
              sizes: tileSizes,
              widths: TILE_WIDTHS,
              gravity: 'top',
            }}
            desktopMinWidth={TILE_DESKTOP_MIN_WIDTH}
            imageClassName="object-top"
          />
        </div>
      )}
      <h4
        className={htmlClasses([
          'absolute desktop:top-5 top-3 desktop:right-4 right-3 desktop:left-4 left-3 m-0 break-words text-graphic-regular-brand',
          titleClassName,
        ])}
      >
        {name}
      </h4>
    </Link>
  );
};

export default observer(BrandCard);
